<script>
  let {
    label = "",
    type = "text",
    value = $bindable(""),
    placeholder = "",
    error = "",
    disabled = false,
    required = false,
    id = "",
    class: className = "",
    oninput = null,
    onblur = null,
    onchange = null,
    onkeydown = null,
  } = $props();
</script>

<div class="space-y-1 {className}">
  {#if label}
    <label for={id} class="block text-sm font-medium text-zinc-300">
      {label}
      {#if required}<span class="text-rose-400">*</span>{/if}
    </label>
  {/if}
  <input
    {id}
    {type}
    {placeholder}
    {disabled}
    {required}
    bind:value
    {oninput}
    {onblur}
    {onchange}
    {onkeydown}
    class="w-full h-10 px-4 bg-black/30 border border-white/10 rounded text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-zinc-400/20 focus:border-zinc-400/40 disabled:opacity-50 text-sm"
  />
  {#if error}
    <p class="text-sm text-rose-400">{error}</p>
  {/if}
</div>
